module.exports = __webpack_public_path__ + "img/SketchPngd86680213eb3bc42ccce4a7593f9a3c106b580c34f47d4e09e099d0a23358eda.1abafd1a.png";